import { Component, OnDestroy, OnInit } from '@angular/core';
import {CatalogueService} from "../../components/catalogue/catalogue.service";
import {EventType, Tabs, Views} from "../../../environments/common";
import {SessionService} from "../../components/common/session/session.service";
import {ItemExhibitorMapped} from "../../models/ItemExhibitorMapped.model";
import {SearchService} from "../../components/search/search.service";
import {ItemProductMapped} from "../../models/ItemProductMapped.model";
import { ActivatedRoute } from '@angular/router';
import { FiltersService } from '../../components/filters/filters.service';
import { Subject, takeUntil } from 'rxjs';
import { AnalyticsService } from '../../components/analytics/analytics.service';

@Component({
  selector: 'app-my-favorites',
  templateUrl: './my-favorites.component.html',
  styleUrls: ['./my-favorites.component.css']
})
export class MyFavoritesComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  eventData: EventType;
  user: string;
  token: string;
  selectedView:string;
  items: any[] = [];
  searchConfig: object = {};
  filter: string;
  favorites: boolean = false;

  exhibitors: any[] = [];
  products: any[] = [];
  exhibitorsDefault: any[] = [];
  productsDefault: any[] = [];
  show: boolean = true;
  
  defaults = {
    tabs: Tabs.ONLY_EXHIBITORS,
    views: Views.LIST
  };
  
  private readonly destroy$ = new Subject();

  constructor(private catalogueService: CatalogueService, private activatedRoute: ActivatedRoute,
              private sessionService: SessionService, public filtersService:FiltersService,
              public searchService: SearchService, private analyticsService: AnalyticsService) {

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.user = JSON.parse(this.sessionService.get('username_' + this.eventData['sapCode'], true) || '{}');
    this.token = JSON.parse(this.sessionService.get('token_' + this.eventData['sapCode'], true) || '{}');
  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params  => {
      const tab = params['tab'];
      this.filter = params['filter'];
      this.favorites = tab === 'favorites' && !this.filter;
    });

    this.getSearchConfig();
    this.getFavoriteResources();

    this.filtersService.getSelectedView()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      this.selectedView = data?.toString();
    });

    
    this.filtersService.getKeyFavorite()
    .pipe(takeUntil(this.destroy$))
    .subscribe(key => {

      if(!key.trim()){

        this.exhibitors = this.exhibitorsDefault;
        this.products = this.productsDefault;
      
      }
      else{

        this.exhibitors = this.exhibitorsDefault.filter(item => {
          return item.exhibitorName.toLowerCase().includes(key.toLowerCase());
        });
        
        this.products = this.productsDefault.filter(item => {
          return item.exhibitorName.toLowerCase().includes(key.toLowerCase());
        });

      }

    });

  }

  uploadData(){

    this.searchService.setSearchConfig(this.searchConfig);

    this.getFavoriteResources();

    this.setPageSize();

  }

  setPageSize() {

    switch(this.selectedView) {
      case 'grid':
        this.searchConfig['size'] = 18;
        break;
      case 'modern':
        this.searchConfig['size'] = 12;
        break;
      case 'list':
        this.searchConfig['size'] = 10;
        break;

    }

  }

  getSearchConfig(){

    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    this.searchConfig = this.searchService.getSearchConfig();
    this.searchConfig['brand'] = '';
    this.searchConfig['sapCode'] = eventData.sapCode;
    this.searchConfig = this.searchService.resetFilters();

  }

  getFavoriteResources() {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    let getFavoriteResourcesIn = {
      event:  this.eventData.eventName,
      token: this.token,
      user: this.user
    };

    this.catalogueService.getFavoriteResources(getFavoriteResourcesIn)
        .subscribe((result) => {
              this.getFavoriteResourcesOk(result);
            },
            error => {
              console.log("[getFavoriteResources]ERROR",error);//FIXME sacar la parte del login
            });

  }

  getFavoriteResourcesOk(data: any){
    this.loader.count--;

    this.exhibitors = [];
    data.favoriteExhibitors.forEach(item => {
      this.exhibitors.push(this.itemsExhibitorMapper(item));
    });
    this.exhibitorsDefault = this.exhibitors;
    this.products = [];
    data.favoriteProducts.forEach(item => {
      this.products.push(this.itemsProductMapper(item));
    });
    this.productsDefault = this.products;
    this.analyticsService.sendViewFavorites(this.exhibitors, this.products);
  }
  
  // FIXME add  isFavorite: true
  itemsExhibitorMapper(item: any): ItemExhibitorMapped {
    let itemMapped: ItemExhibitorMapped = {
      exhibitorId: item.idExhibitor,
      entityId: item.id,
      type: item.type,
      exhibitorDescription: item.exhibitorTranslations,
      exhibitorName: item.name,
      standLocation: item.standLocation,
      mainImage: item.exhibitorImage,
      isFavorite: true,
      favoriteId: item.id,
      sponsoredInHomePage: item.sponsoredInHomePage,
      featured: item.featured,
      note: item.note
    };
    return itemMapped;
  }

  itemsProductMapper(item: any): ItemProductMapped {
    let itemMapped: ItemProductMapped = {
      idProduct: item.idProduct,
      type: item.type,
      productTranslation: item.productTranslation,
      exhibitorName: item.exhibitorName,
      exhibitorId: item.idExhibitor,
      standLocation: item.standLocation,
      mainImage: item.productImage,
      isFavorite: true,
      favoriteId: item.id,
      sponsoredInHomePage: item.sponsoredInHomePage,
      featured: item.featured,
      note: item.note
    };
    return itemMapped;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
